import JsonApiObject from '@/_models/JsonApi'

export default class NotificationResourceModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    moduleId
    forModuleId
    forModulePart
    resourceType
    resourceSubType
    name
}
